import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconMissing: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <rect x="16" y="48" width="20" height="5" fill="#D2D4DA" />
      <rect x="40" y="48" width="20" height="5" fill="#D2D4DA" />
      <rect x="64" y="48" width="20" height="5" fill="#D2D4DA" />
    </svg>
  )
}

export default WeatherIconMissing
